import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

/**
 * Het subleaguebeheer verhuisde van /auction/:id/admin/* naar /auction/:id/beheer/*,
 * en drie pagina's verhuisden helemaal naar het administrator-gedeelte. Deze
 * component vertaalt de oude paden zodat bestaande bookmarks blijven werken.
 */
const SUBLEAGUE_PATHS = {
    overview: 'overzicht',
    auction: 'veilingavond',
    game: 'spelverloop',
    players: 'veilinglijst',
};

const SEASON_PATHS = {
    import: 'stamgegevens',
    scoring: 'puntentelling',
    'points-calculation': 'kalender',
};

function LegacyAdminRedirect({ auction }) {
    const params = useParams();
    // Het deel van het pad ná 'admin/', bijv. 'game' of 'points-calculation'.
    const legacyPath = (params['*'] || '').split('/')[0];

    if (SEASON_PATHS[legacyPath] && auction?.season) {
        return <Navigate to={`/admin/season/${auction.season}/${SEASON_PATHS[legacyPath]}`} replace />;
    }

    const target = SUBLEAGUE_PATHS[legacyPath] || 'overzicht';
    return <Navigate to={`/auction/${auction.id}/beheer/${target}`} replace />;
}

export default LegacyAdminRedirect;
